import { request } from "../helpers/axios.new";

export const GET_APP_VERSION = () => {
  return request({
    url: '/version', 
    method: "GET"
  });
};